import _extends from "@babel/runtime/helpers/esm/extends";
import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
import _slicedToArray from "@babel/runtime/helpers/esm/slicedToArray";
var _excluded = ["width", "title", "theme", "visible", "message", "className", "messageAlign", "closeOnClickOverlay", "onClickCloseIcon"];
import React, { useContext } from 'react';
import clsx from 'clsx';
import Popup from '../popup';
import Button from '../button';
import ActionBar from '../action-bar';
import { addUnit, noop } from '../utils';
import { BORDER_TOP, BORDER_LEFT } from '../utils/constant';
import ConfigProviderContext from '../config-provider/ConfigProviderContext';

var Dialog = function Dialog(props) {
  var _useContext = useContext(ConfigProviderContext),
      prefixCls = _useContext.prefixCls,
      createNamespace = _useContext.createNamespace;

  var _createNamespace = createNamespace('dialog', prefixCls),
      _createNamespace2 = _slicedToArray(_createNamespace, 1),
      bem = _createNamespace2[0];

  var width = props.width,
      title = props.title,
      theme = props.theme,
      visible = props.visible,
      message = props.message,
      className = props.className,
      messageAlign = props.messageAlign,
      closeOnClickOverlay = props.closeOnClickOverlay,
      onClickCloseIcon = props.onClickCloseIcon,
      others = _objectWithoutProperties(props, _excluded);

  var renderTitle = function renderTitle() {
    if (props.title) {
      return /*#__PURE__*/React.createElement("div", {
        className: clsx(bem('header', {
          isolated: !props.message && !props.children
        }))
      }, title);
    }

    return null;
  };

  var renderContent = function renderContent() {
    if (props.children) {
      return /*#__PURE__*/React.createElement("div", {
        className: clsx(bem('content'))
      }, props.children);
    }

    if (message) {
      return /*#__PURE__*/React.createElement("div", {
        className: clsx(bem('content', {
          isolated: !title
        }))
      }, /*#__PURE__*/React.createElement("div", {
        className: clsx(bem('message', _defineProperty({
          'has-title': title
        }, messageAlign, messageAlign)))
      }, message));
    }

    return null;
  };

  var renderButtons = function renderButtons() {
    var _props$cancelProps, _props$cancelProps2, _props$cancelProps3, _props$confirmProps, _props$confirmProps2, _props$confirmProps3;

    return /*#__PURE__*/React.createElement("div", {
      className: clsx(BORDER_TOP, bem('footer'))
    }, props.showCancelButton && /*#__PURE__*/React.createElement(Button, {
      size: "large",
      text: props.cancelButtonText || '取消',
      className: clsx(bem('cancel')),
      style: {
        color: props.cancelButtonColor
      },
      loading: (_props$cancelProps = props.cancelProps) === null || _props$cancelProps === void 0 ? void 0 : _props$cancelProps.loading,
      disabled: (_props$cancelProps2 = props.cancelProps) === null || _props$cancelProps2 === void 0 ? void 0 : _props$cancelProps2.disabled,
      onClick: (_props$cancelProps3 = props.cancelProps) !== null && _props$cancelProps3 !== void 0 && _props$cancelProps3.loading ? noop : props.onCancel
    }), props.showConfirmButton && /*#__PURE__*/React.createElement(Button, {
      size: "large",
      text: props.confirmButtonText || '确认',
      className: clsx(bem('confirm'), _defineProperty({}, BORDER_LEFT, props.showCancelButton)),
      round: theme === 'round-button',
      style: {
        color: props.confirmButtonColor
      },
      loading: (_props$confirmProps = props.confirmProps) === null || _props$confirmProps === void 0 ? void 0 : _props$confirmProps.loading,
      disabled: (_props$confirmProps2 = props.confirmProps) === null || _props$confirmProps2 === void 0 ? void 0 : _props$confirmProps2.disabled,
      onClick: (_props$confirmProps3 = props.confirmProps) !== null && _props$confirmProps3 !== void 0 && _props$confirmProps3.loading ? noop : props.onConfirm
    }));
  };

  var renderRoundButtons = function renderRoundButtons() {
    var _props$cancelProps4, _props$cancelProps5, _props$cancelProps6, _props$confirmProps4, _props$confirmProps5, _props$confirmProps6;

    return /*#__PURE__*/React.createElement(ActionBar, {
      className: clsx(bem('footer'))
    }, props.showCancelButton && /*#__PURE__*/React.createElement(ActionBar.Button, {
      type: "warning",
      text: props.cancelButtonText || '取消',
      className: clsx(bem('cancel')),
      color: props.cancelButtonColor,
      loading: (_props$cancelProps4 = props.cancelProps) === null || _props$cancelProps4 === void 0 ? void 0 : _props$cancelProps4.loading,
      disabled: (_props$cancelProps5 = props.cancelProps) === null || _props$cancelProps5 === void 0 ? void 0 : _props$cancelProps5.disabled,
      onClick: (_props$cancelProps6 = props.cancelProps) !== null && _props$cancelProps6 !== void 0 && _props$cancelProps6.loading ? noop : props.onCancel
    }), props.showConfirmButton && /*#__PURE__*/React.createElement(ActionBar.Button, {
      type: "danger",
      text: props.confirmButtonText || '确认',
      className: clsx(bem('confirm')),
      color: props.confirmButtonColor,
      loading: (_props$confirmProps4 = props.confirmProps) === null || _props$confirmProps4 === void 0 ? void 0 : _props$confirmProps4.loading,
      disabled: (_props$confirmProps5 = props.confirmProps) === null || _props$confirmProps5 === void 0 ? void 0 : _props$confirmProps5.disabled,
      onClick: (_props$confirmProps6 = props.confirmProps) !== null && _props$confirmProps6 !== void 0 && _props$confirmProps6.loading ? noop : props.onConfirm
    }));
  };

  var renderFooter = function renderFooter() {
    if (props.footer) return props.footer;
    return props.theme === 'round-button' ? renderRoundButtons() : renderButtons();
  };

  return /*#__PURE__*/React.createElement(Popup, _extends({}, others, {
    visible: visible,
    className: clsx(bem([theme]), className),
    style: {
      width: addUnit(width)
    },
    "aria-labelledby": title || message,
    closeOnClickOverlay: closeOnClickOverlay,
    onClose: props.onClose,
    onClosed: props.onClosed
  }), renderTitle(), renderContent(), renderFooter());
};

Dialog.defaultProps = {
  closeIcon: 'cross',
  transition: 'rv-dialog-bounce',
  showConfirmButton: true,
  closeOnPopstate: true
};
export default Dialog;